import { mapState } from 'pinia';
import { usePageStore } from '@/store';

export default {
    provide() {
        return {
            params: this.params,
            locations: this.locations
        };
    },
    computed: {
        ...mapState(usePageStore, ['isSearchCenter']),
        locations({ params }) {
            // compose search params
            const searchParamsOpt = {
                city: ',',
                county: ',',
                zipCode: ''
            };
            const locations = [];
            for (let key in params) {
                if (
                    Object.keys(searchParamsOpt).includes(key) &&
                    Array.isArray(params[key]) &&
                    params[key].length
                ) {
                    const values = params[key] || [];
                    const splitFlag = searchParamsOpt[key];
                    values.map(v => {
                        if (v) {
                            const [prev, next] = splitFlag
                                ? v
                                    .split(splitFlag)
                                    .map(v => (v?.trim ? v.trim() : v))
                                : [v?.trim ? v.trim() : v, ''];
                            locations.push({
                                type: key,
                                value: splitFlag ? prev : v,
                                stateCode: splitFlag ? next || '' : ''
                            });
                        }
                    });
                }
            }
            return locations;
        },
        /**
         * @param {Object} props.searchParams
         * @returns {counts:Number,city:Array<String> | Null,zipcode:Array<String> | Null}
         */
        params({ isSearchCenter }) {
            let searchParams;
            try {
                searchParams = JSON.parse(
                    localStorage.getItem('dynamicRegisterParams') || '{}'
                );
            } catch (error) {
                searchParams = {};
            }
            // //  has search history 10-+∞, No search record defaults to 15
            // hasConditon = isSearchCenter
            //     ? searchParams?.condition instanceof Object &&
            //       Object.keys(searchParams.condition).length
            //     : 'keywordType' in searchParams &&
            //       searchParams.keywordType.length &&
            //       'key' in searchParams &&
            //       searchParams.key.length;

            let counts =
                typeof searchParams?.counts === 'number'
                    ? searchParams.counts
                    : undefined;
            let params = {};
            //  Handle address bar parameters x_ads_city， bring to location middle 
            if (searchParams.x_ads_city) {
                params.city = [
                    searchParams.x_ads_city +
                    ',' +
                    (searchParams.x_ads_state || '')
                ];
            } else {
                params.city = [];
            }
            if (searchParams?.hasCondition) {
                counts == undefined && (counts = 0);
                //  Non-middle platform analysis 
                if (
                    !isSearchCenter &&
                    'keywordType' in searchParams &&
                    searchParams.keywordType.length &&
                    'key' in searchParams &&
                    searchParams.key.length
                ) {
                    const keyArr = searchParams.key.split(';');
                    const keyWordTypeArr = searchParams.keywordType.split(';');
                    for (let i = 0; i < keyWordTypeArr.length; i++) {
                        const key = keyWordTypeArr[i].toLowerCase();
                        if (key in params) {
                            params[key].push(keyArr[i]);
                        } else {
                            params[key] = keyArr[i] ? [keyArr[i]] : [''];
                        }
                    }
                } else if (isSearchCenter && searchParams?.condition) {
                    try {
                        let city = params.city || [];
                        params = JSON.parse(searchParams?.condition).location;
                        params.city = params.city.concat(city);
                    } catch (e) {
                        console.log('location analyse error!');
                    }
                }
                return {
                    counts: counts < 10 ? 10 : counts,
                    city: params?.city || null,
                    county: params?.county || null,
                    zipCode: params?.zipCode || params?.zipcode || null
                };
            } else {
                //default
                return {
                    counts: 15,
                    city: params?.city || null,
                    county: null,
                    zipCode: null
                };
            }
        }
    }
};
